var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectFinanceLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CACAFF"
    },
    d: "M396.399,330.269h-262.13c-5.658,0-10.245-4.587-10.245-10.245V132.076 c0-5.658,4.587-10.245,10.245-10.245h262.13c5.658,0,10.245,4.587,10.245,10.245v187.947 C406.644,325.682,402.057,330.269,396.399,330.269z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 178.855,
    y: 213.018,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.64,
    height: 25.933
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.958,
    y: 209.403,
    style: {
      fill: "#41BCBC"
    },
    width: 10.64,
    height: 29.547
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.06,
    y: 203.74,
    style: {
      fill: "#6A6AE2"
    },
    width: 10.641,
    height: 35.211
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.163,
    y: 190.779,
    style: {
      fill: "#171659"
    },
    width: 10.64,
    height: 48.172
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.265,
    y: 177.481,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.641,
    height: 61.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.368,
    y: 184.337,
    style: {
      fill: "#41BCBC"
    },
    width: 10.64,
    height: 54.614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.47,
    y: 180.056,
    style: {
      fill: "#6A6AE2"
    },
    width: 10.641,
    height: 58.895
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 150.9,159.642 150.9,238.951 293.17,238.951  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 160.866,226.095 188.701,193.414 200.385,205.837 248.015,165.625 263.273,179.543 286.984,161.103  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#130F40"
    },
    cx: 286.984,
    cy: 161.103,
    r: 1.461
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#130F40"
    },
    d: "M162.327,226.095c0,0.807-0.654,1.461-1.46,1.461s-1.46-0.654-1.46-1.461 c0-0.807,0.654-1.46,1.46-1.46S162.327,225.288,162.327,226.095z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.9,
    y: 261.044,
    style: {
      fill: "#FFFFFF"
    },
    width: 65.636,
    height: 34.278
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 236.812,
    y1: 261.044,
    x2: 274.779,
    y2: 261.044
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 236.812,
    y1: 267.9,
    x2: 293.17,
    y2: 267.9
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 236.812,
    y1: 274.755,
    x2: 293.17,
    y2: 274.755
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 236.812,
    y1: 281.611,
    x2: 293.17,
    y2: 281.611
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 236.812,
    y1: 288.466,
    x2: 293.17,
    y2: 288.466
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 236.812,
    y1: 295.322,
    x2: 293.17,
    y2: 295.322
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 150.059,
    x2: 361.378,
    y2: 150.059
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 156.914,
    x2: 379.768,
    y2: 156.914
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 163.77,
    x2: 379.768,
    y2: 163.77
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 170.625,
    x2: 379.768,
    y2: 170.625
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 177.481,
    x2: 379.768,
    y2: 177.481
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 184.337,
    x2: 379.768,
    y2: 184.337
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 204.673,
    x2: 361.378,
    y2: 204.673
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 211.528,
    x2: 379.768,
    y2: 211.528
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 218.384,
    x2: 379.768,
    y2: 218.384
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 225.24,
    x2: 379.768,
    y2: 225.24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 232.095,
    x2: 379.768,
    y2: 232.095
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.41,
    y1: 238.951,
    x2: 379.768,
    y2: 238.951
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6AE2"
    },
    d: "M372.958,302.042h-42.738c-3.761,0-6.81-3.049-6.81-6.81v-34.098c0-3.761,3.049-6.81,6.81-6.81 h42.738c3.761,0,6.81,3.049,6.81,6.81v34.098C379.768,298.993,376.719,302.042,372.958,302.042z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.498,272.223c0-7.309-6.075-13.199-13.451-12.897c-6.7,0.275-12.194,5.864-12.362,12.567 c-0.113,4.518,2.102,8.516,5.525,10.905c1.132,0.79,1.773,2.111,1.773,3.491V287c0,0.996,0.808,1.804,1.804,1.804h7.603 c0.996,0,1.804-0.808,1.804-1.804v-0.712c0-1.396,0.668-2.713,1.81-3.515C362.324,280.439,364.498,276.589,364.498,272.223z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#F4CC4D",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 349.238,277.988 350.204,277.988 350.687,278.858 351.729,277.504 352.298,278.697 352.878,277.956 353.941,277.923  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 349.818,
    y1: 288.804,
    x2: 349.238,
    y2: 278.183
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 353.361,
    y1: 288.804,
    x2: 353.941,
    y2: 278.183
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CACAFF"
    },
    d: "M353.197,297.051h-3.214c-1.372,0-2.484-1.112-2.484-2.484v-5.763h8.183v5.763 C355.681,295.939,354.569,297.051,353.197,297.051z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 347.498,
    y1: 290.511,
    x2: 355.681,
    y2: 290.511
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 347.498,
    y1: 292.122,
    x2: 355.681,
    y2: 292.122
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 347.498,
    y1: 293.733,
    x2: 355.681,
    y2: 293.733
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A6AE2",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 347.498,
    y1: 295.344,
    x2: 355.681,
    y2: 295.344
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9A645"
    },
    d: "M36.613,345.23c7.713,29.513,37.89,47.185,67.403,39.473 c29.513-7.712,47.186-37.889,39.474-67.403c-7.713-29.512-37.89-47.185-67.403-39.473 C46.573,285.54,28.901,315.717,36.613,345.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CC4D"
    },
    d: "M34.945,338.846c7.713,29.514,37.89,47.186,67.403,39.474 c29.514-7.712,47.186-37.89,39.473-67.402c-7.712-29.513-37.89-47.187-67.403-39.473 C44.905,279.156,27.232,309.334,34.945,338.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9A645"
    },
    d: "M42.947,336.755c6.558,25.094,32.216,40.121,57.31,33.563 c25.094-6.558,40.121-32.216,33.563-57.311c-6.558-25.094-32.216-40.12-57.311-33.562 C51.415,286.003,36.389,311.662,42.947,336.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CC4D"
    },
    d: "M72.406,332.292c1.148-2.258,2.747-4.133,4.807-5.628c1.779-1.29,4.04-2.68,6.787-4.162 c0.43-0.235,0.877-0.475,1.331-0.717c2.153-1.168,3.896-2.159,5.222-2.998c0.18-0.117,0.352-0.232,0.517-0.337 c1.382-0.896,2.45-1.913,3.208-3.042c0.759-1.129,0.96-2.376,0.599-3.756c-0.513-1.965-1.791-3.325-3.819-4.068 c-1.01-0.369-2.194-0.533-3.561-0.491c-1.394,0.039-2.986,0.298-4.77,0.763c-0.789,0.206-1.575,0.456-2.359,0.749 c-1.356,0.521-2.715,1.166-4.062,1.957c-2.125,1.24-4.075,2.751-5.863,4.544l-4.633-6.208c1.704-1.912,3.886-3.606,6.528-5.086 c1.956-1.082,3.978-1.979,6.076-2.685l-1.856-7.1l7.043-1.841l1.918,7.339c2.306-0.278,4.437-0.255,6.389,0.06 c3.244,0.521,5.873,1.678,7.888,3.478c2.007,1.802,3.362,4.029,4.058,6.691c0.825,3.156,0.668,5.883-0.474,8.166 c-1.144,2.274-2.735,4.147-4.775,5.611c-1.551,1.116-3.5,2.328-5.859,3.647c-0.742,0.422-1.532,0.857-2.357,1.293 c-1.647,0.887-3.046,1.682-4.204,2.389c-0.571,0.334-1.085,0.652-1.535,0.945c-1.379,0.905-2.446,1.93-3.2,3.075 c-0.752,1.153-0.949,2.416-0.591,3.789c0.492,1.882,1.775,3.162,3.832,3.845c1.259,0.417,2.809,0.539,4.631,0.353 c1.163-0.119,2.444-0.358,3.833-0.721c1.093-0.286,2.167-0.645,3.222-1.071c1.732-0.698,3.404-1.591,5.019-2.664 c2.602-1.733,4.686-3.639,6.25-5.716l4.905,6.136c-1.558,2.269-3.929,4.381-7.112,6.345c-2.239,1.375-4.605,2.503-7.105,3.384 l1.875,7.174l-7.043,1.84l-1.888-7.224c-2.69,0.422-5.168,0.446-7.411,0.093c-3.269-0.516-5.904-1.662-7.915-3.445 c-2.009-1.775-3.351-3.988-4.047-6.651C71.09,337.236,71.257,334.55,72.406,332.292z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41BCBC"
    },
    d: "M144.057,355.897l41.18-28.678c7.601-5.293,18.139-2.442,22.033,5.963l19.559,42.213h-23.431 l-11.472-28.09l-33.381,25.525L144.057,355.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M241.537,370.777c0,0,10.775-14.12,21.379-16.21l-8.552,31.945h-15.906L241.537,370.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M148.839,305.884c-0.985-4.392-3.171-8.312-6.219-11.401c-2.768-2.818-6.255-4.943-10.186-6.092 v22.534l3.187,0.039l8.702,43.603l1.047,5.264l13.987-6.927L148.839,305.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41BCBC"
    },
    d: "M105.354,360.857l1.856,11.016c1.424,8.451,8.742,14.638,17.311,14.638h116.546l2.309-18.728 h-92.87l-5.901-16.135L105.354,360.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M145.278,348.03l1.898,5.644l-2.853,0.893l-38.238,11.947c-0.63,0.197-1.284-0.224-1.365-0.879 l-0.644-5.168c-0.77-0.441-1.396-1.067-1.847-1.796c-0.452-0.739-0.718-1.591-0.759-2.473c-0.893-18.564,0.503-42.72,1.58-57.179 c-0.708-2.76-1.95-4.772-4.105-6.28c1.478-1.17,3.099-2.165,4.833-2.955c1.673-0.759,3.448-1.344,5.305-1.693l1.827-0.349 l14.582,16.039l6.106-15.629l0.564,0.154c0.092,0.021,0.185,0.062,0.267,0.082c3.94,1.139,7.419,3.273,10.19,6.095 c1.467,11.257,0.729,22.576,0.072,28.908c-0.359,3.489,0.215,7.009,1.693,10.19l2.955,6.362 C148.664,342.786,147.802,346.162,145.278,348.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M131.599,288.151l-3.592,9.205l-2.514,6.424l-5.131-5.644l-9.451-10.395l1.293-0.246 c1.098-0.215,2.011-0.913,2.524-1.857c0.749,0.164,1.837,0.39,3.14,0.595c3.007,0.482,7.173,0.852,10.949,0.216 c0.082,0.39,0.308,0.729,0.616,0.975c0.164,0.123,0.359,0.226,0.575,0.287L131.599,288.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M141.07,255.303c0-0.01,0-0.01,0-0.01c-1.991-5.141-6.783-9.071-12.889-9.523 c-6.742-0.493-13.094,3.797-15.167,10.231c-1.919,5.972,0.062,12.047,4.32,15.783l-0.021,0.133l-1.467,8.415l-0.727,4.19 c-0.069,0.399-0.206,0.773-0.392,1.116c2.479,0.561,8.684,1.726,14.095,0.806c-0.039-0.178-0.058-0.364-0.036-0.554l0.432-3.773 c8.189,2.658,10.508-6.044,12.663-19.21h-0.021C142.281,260.26,141.963,257.653,141.07,255.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M141.07,255.293c0,0,0,0,0,0.01c-1.652,4.669-15.466-2.094-15.466-2.094 c-1.476,8.744-5.941,15.886-8.291,18.708l0.021-0.133c-4.259-3.735-6.239-9.81-4.32-15.783 c2.073-6.434,8.425-10.724,15.167-10.231C134.287,246.221,139.079,250.152,141.07,255.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M134.722,263.247c0,0-2.832,5.097,3.612,8.063l-5.15,2.256"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#130F40"
    },
    d: "M138.358,267.595c-0.133,0.675,0.006,1.271,0.311,1.33c0.304,0.06,0.658-0.439,0.791-1.114 c0.133-0.675-0.006-1.27-0.31-1.33C138.845,266.422,138.491,266.921,138.358,267.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#130F40"
    },
    d: "M127.9,265.54c-0.133,0.675,0.006,1.27,0.311,1.33c0.304,0.06,0.658-0.439,0.791-1.114 c0.133-0.675-0.006-1.27-0.31-1.33C128.387,264.366,128.033,264.865,127.9,265.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M120.699,266.729c0,0-1.634-7.206-6.359-5.782s-3,15.708,5.056,12.411L120.699,266.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M118.33,269.03c0,0-0.189-4.025-2.394-5.111c-2.205-1.087-2.327,1.863-2.327,1.863"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M116.8,264.843c0,0-2.812,1.503-0.528,5.678"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M128.451,259.2c0,0,2.366-0.641,4.161,0.834"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M138.909,261.509c0,0,2.171-0.898,3.132,1.09"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M128.058,273.566c0,0,0.321,3.207,4.041,3.977"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M129.218,282.117l-0.462,4.074c-9.841-2.935-8.907-11.986-8.907-11.986 S122.732,280.496,129.218,282.117z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M119.592,336.57l12.149-5.633c1.975-0.916,4.296-0.6,5.961,0.802 c3.127,2.634,6.19,4.224,7.372,7.264c1.796,4.618-8.977,4.237-8.977,4.237s-6.811,4.618-13.796,2.651L119.592,336.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M135.669,339.991c0,0,6.419-0.523,8.469,1.834"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M135.242,336.656c0,0,5.982-0.863,9.832,2.348"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M134.814,332.808c0,0,4.297,0.25,8.177,3.203"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M98.943,292.743c-3.845,3.042-6.722,7.266-8.084,12.176c-2.966,10.713-6.137,26.219-5.541,42.104 c0.298,7.666,8.035,12.797,15.259,10.241l23.941-8.466l-4.69-15.772l-17.168,6.403l1.283-28.856 C103.943,301.152,103.402,295.845,98.943,292.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M125.749,294.637l2.258,2.719l-2.514,6.424l-5.131-5.644l1.796-3.499l-4.289-8.405 c3.007,0.482,7.173,0.852,10.949,0.216c0.082,0.39,0.308,0.729,0.616,0.975L125.749,294.637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M131.599,288.151l-2.411,6.167l-6.547-7.573c2.011,0.092,4.156,0.041,6.178-0.298 c0.133,0.595,0.575,1.088,1.19,1.262L131.599,288.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.64,286.746l-5.459,7.891l-6.27-6.896l1.293-0.246c1.098-0.215,2.011-0.913,2.524-1.857 C116.278,285.986,119.284,286.571,122.64,286.746z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 117.181,294.637 122.64,286.746 129.187,294.319  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M102.66,339.43c-5.644,1.929-9.749,5.393-9.749,5.393"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M144.323,354.566l2.853-0.893l-1.898-5.644c2.524-1.868,3.386-5.244,2.063-8.086l-2.955-6.362 c-1.478-3.181-1.962-6.693-1.693-10.19c0.631-8.199-0.055-16.409-2.534-21.668"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 103.943,310.574 102.66,339.43 119.828,333.027 120.798,336.011  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 123.798,346.379 124.518,348.799 101.558,356.918  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 105.354,
    y1: 359.831,
    x2: 140.886,
    y2: 348.799
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6AE2"
    },
    d: "M128.817,367.859h48.117c0.683,0,1.282-0.458,1.46-1.118l9.288-34.416 c0.259-0.961-0.465-1.906-1.46-1.906h-48.117c-0.683,0-1.282,0.458-1.46,1.118l-9.288,34.416 C127.097,366.914,127.821,367.859,128.817,367.859z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 138.535,
    y1: 332.202,
    x2: 129.248,
    y2: 366.618
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CACAFF"
    },
    d: "M135.617,347.304l4.286,16.522c0.616,2.375,2.759,4.033,5.212,4.033h40.708 c1.201,0,2.079-1.134,1.778-2.297l-4.727-18.258H135.617z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 200.289,
    y1: 367.784,
    x2: 223.337,
    y2: 367.859
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 110.911,287.741 125.493,303.78 132.163,288.305  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41BCBC"
    },
    d: "M110.639,194.009v31.656c0,5.764-4.672,10.436-10.436,10.436h-9.451v17.093l-17.081-17.093H51.846 c-5.764,0-10.436-4.673-10.436-10.436v-31.656c0-5.764,4.673-10.436,10.436-10.436h48.357 C105.966,183.573,110.639,188.245,110.639,194.009z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M62.871,218.384c0,1.911-1.549,3.46-3.46,3.46c-1.911,0-3.46-1.549-3.46-3.46 c0-1.911,1.549-3.46,3.46-3.46C61.322,214.923,62.871,216.473,62.871,218.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M79.484,218.384c0,1.911-1.549,3.46-3.46,3.46c-1.911,0-3.46-1.549-3.46-3.46 c0-1.911,1.549-3.46,3.46-3.46C77.935,214.923,79.484,216.473,79.484,218.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M96.097,218.384c0,1.911-1.549,3.46-3.46,3.46s-3.46-1.549-3.46-3.46 c0-1.911,1.549-3.46,3.46-3.46S96.097,216.473,96.097,218.384z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288.66,
    y: 337.616,
    style: {
      fill: "#F4CC4D"
    },
    width: 70.28,
    height: 48.82
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9A645"
    },
    d: "M358.94,337.616v48.82h-24.63c-21.25-10.9-21.76-36.36-20.59-48.82H358.94z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 288.51,
    y1: 374.996,
    x2: 359.083,
    y2: 374.996
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 288.51,
    y1: 362.024,
    x2: 359.083,
    y2: 362.024
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 288.51,
    y1: 349.052,
    x2: 359.083,
    y2: 349.052
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9A645"
    },
    d: "M390.968,332.824c10.251,16.466,5.213,38.125-11.254,48.376 c-16.466,10.251-38.125,5.213-48.377-11.253c-10.251-16.466-5.213-38.125,11.254-48.377 C359.058,311.32,380.717,316.358,390.968,332.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CC4D"
    },
    d: "M388.751,329.262c10.251,16.467,5.213,38.126-11.253,48.377 c-16.466,10.252-38.125,5.213-48.376-11.253c-10.252-16.466-5.213-38.126,11.253-48.377 C356.841,307.758,378.5,312.796,388.751,329.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9A645"
    },
    d: "M384.286,332.042c8.716,14.001,4.433,32.417-9.568,41.133 c-14.001,8.716-32.417,4.433-41.133-9.569c-8.716-14.001-4.432-32.416,9.569-41.133 C357.154,313.757,375.57,318.041,384.286,332.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CC4D"
    },
    d: "M369.344,343.689c-1.544-0.458-3.109-0.539-4.7-0.242c-1.373,0.257-3.004,0.693-4.889,1.313 c-0.297,0.096-0.603,0.197-0.913,0.301c-1.481,0.483-2.7,0.854-3.667,1.1c-0.133,0.032-0.261,0.061-0.382,0.091 c-1.018,0.246-1.954,0.294-2.807,0.151c-0.853-0.143-1.516-0.596-1.996-1.366c-0.682-1.096-0.752-2.281-0.208-3.542 c0.272-0.627,0.713-1.246,1.331-1.859c0.628-0.627,1.443-1.248,2.438-1.868c0.44-0.274,0.899-0.528,1.377-0.762 c0.834-0.398,1.725-0.744,2.68-1.02c1.502-0.439,3.052-0.678,4.661-0.719l-0.839-4.853c-1.628-0.049-3.364,0.217-5.203,0.789 c-1.355,0.43-2.653,0.971-3.897,1.631l-2.466-3.962l-3.93,2.446l2.549,4.095c-1.137,0.943-2.058,1.937-2.767,2.976 c-1.178,1.726-1.793,3.445-1.844,5.162c-0.046,1.714,0.39,3.314,1.314,4.799c1.096,1.761,2.424,2.881,3.977,3.352 c1.55,0.467,3.11,0.551,4.679,0.249c1.194-0.228,2.605-0.597,4.246-1.11c0.519-0.158,1.066-0.333,1.628-0.523 c1.13-0.373,2.108-0.67,2.941-0.896c0.404-0.118,0.776-0.216,1.108-0.295c1.021-0.241,1.96-0.285,2.819-0.133 c0.861,0.157,1.53,0.619,2.007,1.384c0.654,1.05,0.684,2.202,0.099,3.451c-0.358,0.764-0.98,1.533-1.862,2.292 c-0.564,0.485-1.234,0.972-2.009,1.454c-0.61,0.379-1.245,0.718-1.903,1.019c-1.08,0.494-2.223,0.875-3.424,1.152 c-1.938,0.443-3.729,0.572-5.372,0.386l0.688,4.948c1.729,0.273,3.741,0.102,6.039-0.508c1.614-0.433,3.169-1.031,4.669-1.8 l2.492,4.003l3.929-2.446l-2.509-4.03c1.371-1.057,2.466-2.191,3.284-3.38c1.191-1.734,1.815-3.452,1.871-5.161 c0.059-1.703-0.376-3.291-1.3-4.776C372.201,345.244,370.888,344.146,369.344,343.689z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M358.94,386.435h-0.09c-10.89-0.72-21.29-6.51-27.51-16.49c-0.37-0.6-0.72-1.2-1.05-1.82c-0.41-0.56-0.8-1.14-1.17-1.74 c-5.57-8.95-6.62-19.42-3.78-28.77"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M439.671,378.089c-3.26-0.3-3.69-1.83-8.04-1.83c-4.81,0-5.18,2.57-7.87,2.57 c-0.97,0-1.61-0.33-2.02-0.76l0.77-8.31h12.31C436.641,372.029,438.32,375.159,439.671,378.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M443.07,386.509h-22.12l0.79-8.44c0.41,0.43,1.05,0.76,2.02,0.76c2.69,0,3.06-2.57,7.87-2.57 c4.35,0,4.78,1.53,8.04,1.83C441.74,382.519,443.07,386.509,443.07,386.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M387.82,381.387c5.242-1.694,14.458-4.585,19.21-3.723l-0.147-7.902h-12 c-4.309,2.681-9.234,6.99-13.026,10.567C382.306,381.369,383.666,382.729,387.82,381.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M387.82,381.387c-4.154,1.343-5.515-0.018-5.963-1.058c-3.633,3.427-6.224,6.183-6.224,6.183 h31.563l-0.165-8.848C402.278,376.802,393.062,379.692,387.82,381.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#130F40"
    },
    d: "M443.65,188.999c-0.16,4.22-8.33,10.37-8.33,10.37s-21.42-2.17-26.75-3.75 c-5.33-1.59-7.25-7.09-3.92-10.09c3.34-3,5.09-8.84-0.41-8.85c-5.5,0-4.5-4.88-4.5-4.88c-1.67-0.16-4.42-1.85-4.5-5.52 c-0.09-3.68,4.41-5.3,4.41-5.3c-1.08-0.8-3-9.28,11.59-14.53c1.61-0.58,3.06-0.98,4.37-1.25c10.56-2.11,11.89,5.08,11.89,5.08 c14.76,1.67,6.82,21.52,6.82,21.52s3.17-0.1,3.17,2.96s-3.75,4.63-3.75,4.63s2.29-0.34,3.68,0.68c0.47,0.34,0.83,0.83,0.98,1.55 c0.56,2.67-2.45,4.89-2.8,5.14C439.1,185.029,443.82,184.789,443.65,188.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6AE2"
    },
    d: "M449.141,222.629l-1.05,3.75l-9.6,4.1l-2.54,1.09l-3.01-11.7l-1.55-6.04H401.4l-8.13,8.65 l-4.2,4.47l-1.48-1.52l-9.78-9.98c2.79-3.98,5.61-7.5,8.5-10.54c3.04-3.21,6.16-5.89,9.42-8.02c6.13-4.02,12.75-6.11,20.23-6.11 c4.39,0,8.39,0.55,11.9,1.35c5.24,1.2,9.82,4.07,13.19,8.01c2.37,2.76,4.14,6.05,5.13,9.67c0.09,0.32,0.17,0.65,0.25,0.98 L449.141,222.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M448.09,226.379l-5.11,18.29c-0.36-0.56-0.65-1.2-0.86-1.91l-3.63-12.28L448.09,226.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M403.57,244.569l-5.88,9.88l-21.43-18.28c-4.37-3.72-5.37-10.1-2.3-14.94 c1.28-2.02,2.56-3.95,3.85-5.78l9.78,9.98l-2.64,2.64L403.57,244.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6AE2"
    },
    d: "M430.74,225.219c-1.76,4.29-2.1,9.06-0.85,13.52c1.13,4.01,2,8.16,2.68,12.61H395.9 c1.87-10.59,2.14-16.48-1.45-24.15c-0.69-1.47-1.05-3.07-1.18-4.72c-0.58-7.32,3.42-15.41,3.42-15.41l-0.96-10.18 c3.42-2.25,7-3.89,10.79-4.9c-0.23,1.95-0.14,6.84,6.78,6.84c6.65,0,11.47-4.76,13.35-6.96c0.41,0.08,0.81,0.17,1.21,0.26 c5.24,1.2,9.82,4.07,13.19,8.01l-8.11,19.73L430.74,225.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M432.572,251.35h-36.668c-0.08,0.452-0.158,0.899-0.244,1.369c-2.09,11.48-7.21,117.98-7.21,117.98 h21.74l3.5-95.25l4.26,95.25h20.24c0,0-2.74-85.87-3.74-101C434.003,262.926,433.428,256.908,432.572,251.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M423.87,175.969l-0.228,14.01c-0.013,0.78,0.554,1.44,1.323,1.573 c0.571,0.098,1.133,0.204,1.685,0.317c-1.88,2.2-6.7,6.96-13.35,6.96c-6.92,0-7.01-4.89-6.78-6.84 c0.747-0.2,1.502-0.373,2.27-0.523c0.693-0.135,1.202-0.729,1.258-1.433l0.082-1.034l0.44-5.38c-8.33,1-8.92-7.75-8.5-20.75 l0.02,0.01c0.312-8.332,7.67-14.868,16.298-13.819c6.536,0.794,11.812,6.092,12.579,12.631 C431.679,167.764,428.647,173.199,423.87,175.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#130F40"
    },
    d: "M437.421,180.069h-9.97c-4.82-5.62-4.38-15.87-4.38-15.87c-11.56-4.81-7.38-16.25-7.38-16.25 l-0.08-2.75c10.56-2.11,11.89,5.08,11.89,5.08c14.76,1.67,6.82,21.52,6.82,21.52s3.17-0.1,3.17,2.96s-3.75,4.63-3.75,4.63 S436.03,179.049,437.421,180.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M417.07,174.759c0,0-0.62,0.76-1.51,1.61c-1.99,1.88-5.33,4.2-6.02-0.64l0.34-0.04L417.07,174.759z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M417.07,174.759c0,0-0.62,0.76-1.51,1.61c-4.32,1.6-5.41,0.23-5.68-0.68L417.07,174.759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M409.274,166.887c0,2.036-1.896,3.688-4.234,3.688c-2.339,0-4.234-1.651-4.234-3.688c0-2.037,1.896-3.688,4.234-3.688 C407.378,163.199,409.274,164.85,409.274,166.887z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 416.296,
    cy: 166.887,
    rx: 4.234,
    ry: 3.688
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M410.008,163.824c0,0,1.75,5.406-4.969,7.031l4.5,3.125"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M409.274,166.887c0,0,0.935-1.375,2.788,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#130F40"
    },
    d: "M406.664,166.85c0,0.67-0.245,1.214-0.547,1.214c-0.302,0-0.547-0.543-0.547-1.214 s0.245-1.214,0.547-1.214C406.419,165.637,406.664,166.18,406.664,166.85z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#130F40"
    },
    cx: 416.503,
    cy: 166.85,
    rx: 0.547,
    ry: 1.214
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M402.495,159.976c0,0,2.249-1.871,5.131-0.684"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M411.758,159.199c0,0,2.969-1.719,6.531,0"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 420.53,
    y1: 166.887,
    x2: 428.24,
    y2: 168.449
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M421.81,179.389c-0.28,0.46-4.43,7.21-11.68,9.61l0.44-5.38 C418.16,183.209,421.6,179.609,421.81,179.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M423.237,172.866c0,0,2.917-6.583,7.167-4.333s-0.083,15.583-7.167,10.917V172.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M425.07,175.512c0,0,0.938-3.813,3.25-4.438s1.875,2.219,1.875,2.219"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M427.32,171.795c0,0,2.406,1.966-0.562,5.529"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M393.27,222.479c-0.58-7.32,3.42-15.41,3.42-15.41"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 431.391,
    y1: 213.829,
    x2: 432.94,
    y2: 219.869
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M462.38,204.699c-0.19,2.37-0.19,6.44-1.31,9.5c-0.52,4.47-1.17,8.89-1.89,13.15 c0,0.03-0.01,0.07-0.02,0.11c-0.88,5.21-1.88,10.2-2.89,14.79c-0.15,0.69-0.38,1.32-0.68,1.89c-2.51,4.9-9.71,5.19-12.61,0.53 l6.16-22.04l2.81-10.04l-1.92-9.08c-0.35-1.66-0.13-3.38,0.61-4.9c1.92-3.94,5.8-11.27,7.68-10.35c2.56,1.25-2.56,4.58-3.44,10.57 c0,0,6.69-11.72,9-9.83c2.31,1.89-2.61,3.85-5.36,10.35c0.32-0.42,5.84-7.8,7.36-6.28c1.57,1.57-3.49,4.44-5.3,8.62 c0.24-0.29,4.42-5.33,5.99-4.36C468.19,198.329,462.57,202.329,462.38,204.699z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 448.09,
    y1: 226.379,
    x2: 445.697,
    y2: 234.949
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0",
      stroke: "#FF8E77",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M452.195,201.449c0,0,6.233-6.329,7.991-4.196c1.758,2.133-2.866,3.571-3.116,4.946c0,0,0.875,2.99,0.375,4.87"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CC4D"
    },
    d: "M428.553,142.471c0,0,0.196-14.491,14.509-14.474c0,0-14.491-0.196-14.474-14.509 c0,0-0.196,14.491-14.509,14.474C414.079,127.962,428.571,128.159,428.553,142.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CC4D"
    },
    d: "M444.543,153.001c0,0,0.098-7.249,7.258-7.241c0,0-7.249-0.098-7.241-7.258 c0,0-0.098,7.249-7.258,7.241C437.302,145.743,444.552,145.841,444.543,153.001z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 33.137,
    y1: 386.512,
    x2: 463.667,
    y2: 386.512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6AE2"
    },
    d: "M321.822,343.236h-96.8c0-7.87,6.38-14.25,14.25-14.25h0.17c-0.07-0.7-0.1-1.41-0.1-2.13 c0-12.08,9.79-21.87,21.87-21.87c9.45,0,17.51,5.99,20.56,14.39c1.47-0.4,3.01-0.61,4.61-0.61c9.12,0,16.63,6.86,17.67,15.71 c1.86-1.44,4.19-2.29,6.72-2.29C316.872,332.186,321.822,337.136,321.822,343.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6AE2"
    },
    d: "M186.336,144.467H71.767c0-9.315,7.551-16.866,16.866-16.866h0.201 c-0.083-0.828-0.118-1.669-0.118-2.521c0-14.298,11.587-25.885,25.885-25.885c11.185,0,20.724,7.09,24.334,17.032 c1.74-0.474,3.563-0.722,5.456-0.722c10.794,0,19.683,8.119,20.914,18.594c2.202-1.704,4.959-2.71,7.954-2.71 C180.478,131.389,186.336,137.248,186.336,144.467z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectFinanceLoan);
export default __webpack_public_path__ + "static/media/project-finance-loan.5b0ed10eafbe6101c562502f9c1f11a3.svg";
export { ForwardRef as ReactComponent };